
import privacyConsent from '~/features/privacyConsent';

export default {
    name: 'Cookies',
    methods: {
        giveConsent() {
            privacyConsent.grantConsent();
            this.$store.commit('app/setShowCookiesBanner', false);
            this.$analytics.trackEvent('cookiesConsented');
        },
        reject() {
            this.$store.commit('app/setShowCookiesBanner', false);
            this.$analytics.trackEvent('cookiesRejected');
        },
    },
    computed: {
        show() {
            return this.$store.getters['app/getShowCookiesBanner'];
        },
    },
};
